import * as React from 'react';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import { SimpleCall, EPageTypes, EPlatformTypes } from '@cian/frontend-newbuilding-call-component';
import { useSelector } from 'react-redux';
import { IBuilder } from '@cian/frontend-newbuilding-call-component/es/types/builder';
import { ISeller } from '@cian/frontend-newbuilding-call-component/es/types/seller';

import { getBuilders, getSellers } from '../../selectors/newbuildingInfo';
import { useApplicationContext } from '../../utils/applicationContext';

export interface ICallButtonProps {
  placeType: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onShowPhoneClick: (params: any) => void;
  onOpenContactsClick: () => void;
}

export const CallButton: React.FC<ICallButtonProps> = ({ placeType, onShowPhoneClick, onOpenContactsClick }) => {
  const builders = useSelector(getBuilders);
  const sellers = useSelector(getSellers);
  const platformType = EPlatformTypes.WebDesktop;

  const { httpApi, logger } = useApplicationContext();

  if (!httpApi || !logger) {
    return null;
  }

  return (
    <SimpleCall
      httpApi={httpApi}
      logger={logger}
      builders={builders as IBuilder[]}
      sellers={sellers as ISeller[]}
      onShowPhoneClick={onShowPhoneClick}
      onOpenContactsClick={onOpenContactsClick}
      openContactsStyles={{ size: 'XS' as const }}
      showPhoneStyles={{ size: 'XS' as const, beforeIcon: <IconCommunicationPhone16 color="icon-inverted-default" /> }}
      pageType={EPageTypes.NewbuildingReviews}
      placeType={placeType}
      platformType={platformType}
    />
  );
};
